import React from "react";
import { Popover, PopoverProps } from "@mantine/core";

export function EPopover({ ...props }: PopoverProps) {
  return (
    <Popover shadow="sm" radius="lg" withArrow arrowSize={14} {...props} />
  );
}
